import styles from './spinner.module.scss'

export const Spinner = ({type = null}) => 
<div className={type ? styles.simulator : styles.loader}></div>
